import { useState,useEffect,useRef } from "react";
import axios from 'axios';
import { useAuthLocalStorage } from '../../modules/useLocalStore';
import React from "react";
import style from './chat.module.css'
import notice from '../../img/notice.svg';
import logomin from '../../img/logo_min.png'
import add from '../../img/add.svg'
import gift from '../../img/gift_send.png'
import smile from '../../img/smile.png'
import send from '../../img/send.svg'
import EmojiPicker from 'emoji-picker-react';


import back from '../../img/backdia.svg'
import Photo from "../../modules/Photo/photo";
import nopic from '../../img/no_photo_neutral.svg';

function Chat({myProfile,activePhoto,setMyProfile,setActivePhoto,setAllChats, allChats, setUserMessage, message,playSound,socketRef,setPage}){

    
    const [inputMess, setInputMess] = useState('');
    const [emojiblock, setEmojiBlock] = useState(false);
    const { getToken, removeToken } = useAuthLocalStorage();
    const token = getToken();
    

   
    
   
    const setActiveChat = (id) =>
    {
        setMyProfile(prevState => ({
            ...prevState,
            activeChat: id
        }));

    };
    function convertUnixtimeToTime(unixTimestamp) {
        const date = new Date(unixTimestamp * 1000);
        const hours = date.getHours().toString().padStart(2, '0'); // добавляем ведущий ноль, если часы меньше 10
        const minutes = date.getMinutes().toString().padStart(2, '0'); // добавляем ведущий ноль, если минуты меньше 10
        return `${hours}:${minutes}`;
    }
    const TimeDisplay = ({ zz }) => {
        const formattedTime = convertUnixtimeToTime(zz);
        
        return (<>{formattedTime}</>);
      };
   
    const sortedChats = allChats.slice().sort((a, b) =>  b.last - a.last);
    useEffect(() => {
        if(myProfile.activeChat != null)
        {
            PopupOpen(21);
            const url = `https://winxy.ru:${process.env.REACT_APP_PORT_SERVER}/api/getMessage`;
            const config = {
                headers: {
                    Authorization: "Bearer " + token
                }
            };
            
            const chatid = allChats.find(item => item.id === myProfile.activeChat);
            const metaDate = {
                "chatid" : myProfile.activeChat
            }; 
            axios.post(url,metaDate, config)
            
                .then(response => {
                    if(response.data.message)
                    {
                        setUserMessage(response.data.date);
                         
                         
                    }
                    else 
                    {
                         setUserMessage([]);
                    }
                    exitPopup();
                })
                    .catch(error => {
                        setUserMessage([]);
                        console.log(error);
                        exitPopup();
                    
                        
                });
            
        }
        
    }, [myProfile.activeChat,setUserMessage]);
    const exitPopup = () => {
        setMyProfile(prevState => ({
            ...prevState,
            info: {
                ...prevState.info,
                popup: null
            }
        }));
    }
    useEffect(() => {
        scrollToBottom();
      }, [message]); 
    const scrollRef = useRef(null);
      
    const scrollToBottom = () => {
        setTimeout(() => {
            if (scrollRef.current) {
                const maxScrollTop = scrollRef.current.scrollHeight - scrollRef.current.clientHeight;
                scrollRef.current.scrollTop = maxScrollTop;
            }
        }, 100);
    };
    const submitMessage = e => {
        if(inputMess === null || inputMess === '') return false;
        if(myProfile.money <= 0)
        {
             if(myProfile.vip <= 0) PopupOpen(31);
            else PopupOpen(8);
            setInputMess('');
            return false;
        } 
        if(!needsMasking(inputMess)) PopupOpen(6);
        
        const body = {
                text: inputMess,
                id: allChats.find(item => item.id === myProfile.activeChat).userid
            }
            const config = {
                headers: {
                    Authorization: "Bearer " + token
                }
            };
            
            axios.post(`https://winxy.ru:${process.env.REACT_APP_PORT_SERVER}/api/sendMess`, body,config)
            .then(response => {
                if(response.data.insertid)
                {
                    
                    const insertid = response.data.insertid;
                    const roomid = response.data.id_room;
                    setMyProfile(prevState => ({
                        ...prevState,
                        money: response.data.money
                    }));
                }
                else
                {
                    if(response.data.err)
                    {
                    
                        setMyProfile(prevState => ({
                            ...prevState,
                            money: response.data.money
                        }));
                        setInputMess('');
                        if(myProfile.vip <= 0) PopupOpen(31);
                        else PopupOpen(8);
                        
                        return false;
                    }
                }
            })
            .catch(error => {
                console.error('Error uploading image:', error);
            });
    
        setInputMess('');
        scrollToBottom();
    };
    const onEmojiClick = (event, emojiObject) => {
        setInputMess((prevMessages) => {
            return prevMessages + event.emoji;
        });
        setEmojiBlock(false);
      };
    const ClickPhoto = (e) => {
        if(myProfile.vip <= 0)
        {
            e.preventDefault();
            PopupOpen(30);
        }
    };
    const handleImageUpload = (e) => {
        const file = e.target.files[0];
        const room = allChats.find(item => item.id === myProfile.activeChat).id;
        if (file) {
            handleUpBD(file,room);
        }
    };
    const handleUpBD = (image,room) => {
        if(token !== null)
        {
            const formData = new FormData();
            formData.append('image', image);
            formData.append('room', room);
            
            const config = {
                headers: {
                    Authorization: "Bearer " + token,
                    'Content-Type': 'multipart/form-data'
                }
            };

            axios.post(`https://winxy.ru:${process.env.REACT_APP_PORT_SERVER}/api/addPhotoMessage`, formData,config)
            .then(response => {
                if(response.data.insertid)
                {
                    
                }
            })
            .catch(error => {
                console.error('Error uploading image:', error);
            });
        }
    };
    function handleKeyDown(event) {
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        if (!isMobile && event.key === 'Enter') {
            event.preventDefault();
            submitMessage();
        }
    }
    const PopupOpen = (ind) => {
        setMyProfile(prevState => ({
            ...prevState,
            info: {
                ...prevState.info,
                popup: ind
            }
        }));
    };
    const sendGift = () => {
        
        setMyProfile(prevState => ({
            ...prevState,
            sendselect: allChats.find(item => item.id === myProfile.activeChat).userid
        }));
        PopupOpen(9);
    };
    function needsMasking(text) {
        if(myProfile.vip > 0) return true;
        const numberWords = [
            "ноль","один","два","три","четыре","пять","шесть","семь","восемь","девять"
        ];

        const tgWords = [
            "тг", "tg", "телеграм", "телеграмм",
            "telegram", "telegramm", "телега", "тгшка", "тэгэ"
        ];

        // 1. Проверка на последовательности цифр >=3
        if (/\d{3,}/.test(text)) return false;

        // 2. Проверка на слитные слова-цифры >=3
        const concatenatedWordsRegex = new RegExp(`(?:${numberWords.join("|")}){3,}`, "gi");
        if (concatenatedWordsRegex.test(text)) return false;

        // 3. Разбиваем текст по пробелам для проверки последовательности слов-цифр и TG
        const words = text.split(/\s+/);

        for (let i = 0; i < words.length; i++) {
            const word = words[i].toLowerCase();

            // Проверка на TG-слова
            if (tgWords.some(tgWord => word.includes(tgWord))) {
                if (i + 1 < words.length) {
                    // если после TG есть ник — маска нужна
                    return false;
                }
            }

            // Проверка последовательности слов-цифр через пробел
            if (numberWords.includes(word)) {
                let j = i;
                while (j < words.length && numberWords.includes(words[j].toLowerCase())) {
                    j++;
                }
                if (j - i >= 3) return false;
            }

            // Проверка на никнеймы (англ + цифры) >=3 символов
            if (/^[a-zA-Z0-9@._-]{3,}$/.test(words[i])) return false;
        }

        // Если ничего не найдено, возвращаем true
        return true;
    }

  function sanitizeText(text) {
    if(myProfile.vip > 0) return text;
    const numberWords = [
        "ноль","один","два","три","четыре","пять","шесть","семь","восемь","девять"
    ];

    const tgWords = [
        "тг", "tg", "телеграм", "телеграмм",
        "telegram", "telegramm", "телега", "тгшка", "тэгэ"
    ];

    let maskCount = 0; // для уникальных ключей

    // 1. Скрываем последовательности цифр ≥3
    text = text.replace(/\d{3,}/g, "###MASK###");

    // 2. Скрываем слитные слова-цифры ≥3
    const concatenatedWordsRegex = new RegExp(`(?:${numberWords.join("|")}){3,}`, "gi");
    text = text.replace(concatenatedWordsRegex, "###MASK###");

    // 3. Разбиваем текст по пробелам
    const words = text.split(/\s+/);
    const result = [];
    let i = 0;

    while (i < words.length) {
        const word = words[i];
        const lowerWord = word.toLowerCase();

        // 3a. Проверка на TG-слова
        const isTG = tgWords.some(tgWord => lowerWord.includes(tgWord));
        if (isTG) {
            result.push(word + " "); // оставляем TG слово
            if (i + 1 < words.length) {
                // скрываем следующий ник/слово после TG
                result.push(
                    <React.Fragment key={`mask${maskCount}`}>
                        <span key={`maskbtn${maskCount}`} className={style.maskbtn} onClick={() => PopupOpen(6)}>Данные скрыты</span>
                        <span key={`maskinfo${maskCount}`} className={style.infomask} onClick={() => PopupOpen(6)}>i</span>
                    </React.Fragment>
                );
                maskCount++;
                i += 2;
                continue;
            }
        }

        // 3b. Последовательность слов-цифр через пробел
        if (numberWords.includes(lowerWord)) {
            let j = i;
            while (j < words.length && numberWords.includes(words[j].toLowerCase())) {
                j++;
            }
            if (j - i >= 3) {
                result.push(
                    <React.Fragment key={`mask${maskCount}`}>
                <span key={`maskbtn${maskCount}`} className={style.maskbtn} onClick={() => PopupOpen(6)}>Данные скрыты</span>
                <span key={`maskinfo${maskCount}`} className={style.infomask} onClick={() => PopupOpen(6)}>i</span>
             </React.Fragment>
                );
                maskCount++;
                i = j;
                continue;
            }
        }

        // 3c. Если слово помечено как маска
        if (word.includes("###MASK###")) {
            result.push(
               <React.Fragment key={`mask${maskCount}`}>
                <span key={`maskbtn${maskCount}`} className={style.maskbtn} onClick={() => PopupOpen(6)}>Данные скрыты</span>
                <span key={`maskinfo${maskCount}`} className={style.infomask} onClick={() => PopupOpen(6)}>i</span>
             </React.Fragment>
            );
            maskCount++;
        }
        // 3d. Скрываем никнеймы (англ + цифры) ≥3 символов
        else if (/^[a-zA-Z0-9@._-]{3,}$/.test(word)) {
            result.push(
              <React.Fragment key={`mask${maskCount}`}>
                <span key={`maskbtn${maskCount}`} className={style.maskbtn} onClick={() => PopupOpen(6)}>Данные скрыты</span>
                <span key={`maskinfo${maskCount}`} className={style.infomask} onClick={() => PopupOpen(6)}>i</span>
             </React.Fragment>
            );
            maskCount++;
        }
        else {
            result.push(word + " ");
        }

        i++;
    }

    return result;
}






    const clickprofile = (id) => {
        setMyProfile(prevState => ({
            ...prevState,
            info: {
                ...prevState.info,
                profile: id
            }
        }));
        setPage(5);
        exitPopup();
    };
    return (
        
        <div className={style.flexblock + ' ' + (myProfile.activeChat != null ? style.chatactive : null)}>
            
            <Photo activePhoto={activePhoto} setActivePhoto={setActivePhoto} />
            <div className={style.leftblock}>
                <h2>Мои чаты</h2>
                {myProfile.vip <= 0 ?
                    <button className={style.vipbtn} onClick={() => PopupOpen(29)}>Получить VIP</button>
                    : null
                }
                <div className={style.scrollchats}>
                    {allChats[0] ? 
                    sortedChats.map((chat,index) =>
                        <div key={chat.id} className={style.btnChat} onClick={ (() => {setActiveChat(chat.id);})}>
                            <div className={style.flexbtn}>
                                <div className={style.leftbtn}>
                                    {chat.photo ? <img src={`https://winxy.ru/static_img.php?id=${chat.photo}`} alt=""/> :  <img src={nopic} alt=""/>}
                                    <div className={style.textname}>
                                        <h4>{chat.name}</h4>
                                        {chat.lastM === 0 ? <p>Прочитано</p> : <p>Не прочитано</p> }
                                    </div>
                                </div>
                                <div className={style.rightbtn}>
                                    <p><TimeDisplay zz={chat.last}/></p>
                                    {chat.lastM === 1 && chat.id_last !== myProfile.userid ? <img src={notice} alt=""/> : null}
                                </div>
                            </div>
                        </div>
                    )
                    : <h5>Диалогов нет</h5>
                    }
                </div>
            </div>
            <div className={style.rightblock}>
                {!myProfile.activeChat ?  <h1>Выбирите диалог</h1> :
                <div className={style.flexbigblock}>
                    <div className={style.chattop}>
                        <div className={style.flexchattop}>
                            <img src={back} alt="" className={style.backdia} onClick={(() => {setActiveChat(null);})}/>
                            {allChats.find(item => item.id === myProfile.activeChat).photo && allChats.find(item => item.id === myProfile.activeChat).photo !== null ? <img src={`https://winxy.ru/static_img.php?id=${allChats.find(item => item.id === myProfile.activeChat).photo}`} alt="" className={style.photoprof}  onClick={() => clickprofile(allChats.find(item => item.id === myProfile.activeChat).userid)}/> : <img src={nopic} alt="" className={style.photoprof}  onClick={() => clickprofile(allChats.find(item => item.id === myProfile.activeChat).userid)}/> }
                            <div onClick={() => clickprofile(allChats.find(item => item.id === myProfile.activeChat).userid)}>
                                <h3>{allChats.find(item => item.id === myProfile.activeChat).name}</h3>
                                <p>Ждет Вашего сообщения</p>
                            </div>
                        </div>
                        <img className={style.logomin} src={logomin} alt=""/>
                    </div>
                    <div className={style.chatbody} ref={scrollRef}>
                        {message ? 
                        message.map((mess,index) =>
                            
                           (mess.id_for === myProfile.userid ?
                            
                                <div className={style.messageof +  (mess.present === 1 ? ' ' + style.presents : '')} key={index}>
                                   
                                   <span>
                                        {mess.present === 1 && <h3>Вы отправили подарок:</h3>}

                                        {mess.ph ? (
                                            <img
                                            src={mess.ph}
                                            onClick={() => setActivePhoto(mess.ph)}
                                            alt=""
                                            />
                                        ) : (
                                            <>
                                            {sanitizeText(mess.text)}
                                            </>
                                        )}
                                        </span>

                                    <p><TimeDisplay zz={mess.time}/></p>
                                </div>
                            :
                                <div className={style.messageto +  (mess.present === 1 ? ' ' + style.presents : '')} key={index}>
                                    <span>
                                        {mess.present === 1 && <h3>Вам отправили подарок:</h3>}

                                        {mess.ph ? (
                                            <img
                                            src={mess.ph}
                                            onClick={() => setActivePhoto(mess.ph)}
                                            alt=""
                                            />
                                        ) : (
                                            <>
                                            {sanitizeText(mess.text)}
                                            </>
                                        )}
                                        </span>
                                    <p><TimeDisplay zz={mess.time}/></p>
                                </div>
                            )
                        )
                        :
                        <h3>Сообщений нет</h3>
                    }
                    </div>
                    <div className={style.chatbottom}>
                        {emojiblock ?
                        <div className={style.smileadd}>
                            <EmojiPicker onEmojiClick={onEmojiClick} width='300' searchDisabled='false'/>
                        </div>
                        :
                        null
                        }
                        <div className={style.chatsattr}>
                            <label htmlFor='addphoto'>
                                <img src={add} alt="" className={style.addbtn}/>
                            </label>
                            <input
                                type="file"
                                id='addphoto'
                                accept="image/*"
                                onClick={(e) => ClickPhoto(e)}
                                onChange={(e) => handleImageUpload(e)}
                                style={{ display: 'none' }}
                            />
                            <textarea placeholder="Напиши сообщение..." className={style.textare} value={inputMess} onChange={e => setInputMess(e.target.value)} onKeyDown={handleKeyDown}/>
                            <div className={style.rightcontent}>
                                <img src={gift} alt="" className={style.giftsend} onClick={sendGift}/>
                                <img src={smile} alt ="" className={style.smilesend} onClick={
                                    ()=> (
                                    setEmojiBlock(prevState => (
                                        !prevState))
                                )
                                }/>
                                <div className={style.btnsend} onClick={submitMessage}>
                                    <img src={send} alt=""/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                }
            </div>
        </div>
    );
}
export default Chat;